<template>
  <PxStickyContainer v-if="!hideHelpBar && !hideChatLauncher" position="bottom-right">
    <HpButton
      v-if="!hideChatLauncher"
      id="sticky-help-btn"
      class="relative h-fit max-w-52 !rounded-full"
      @click="onRequestChat"
      variant="secondary"
    >
      <div
        class="absolute -top-4 right-0 flex size-8 items-center justify-center rounded-full bg-danger text-center font-semibold text-white"
        v-if="unreadMessages > 0"
      >
        {{ unreadMessages }}
      </div>
      <HpIcon name="message" class="mr-1" />
      {{ content.ext.chat_text }}
    </HpButton>
  </PxStickyContainer>
</template>

<script lang="ts" setup>
  import { PlanType } from '~/generated/api-clients-generated'
  import { EngineStore } from '~/stores/engine'

  const { getComponentContent } = Cms.use()
  const { content } = await getComponentContent('QuotesStickyActions', 'BottomBar')
  const { isHideCsChat } = PdpPushToCsConfig.use()

  const { flag } = FeatureFlags.use()
  const hideChatLauncher = computed(() => flag<boolean>('hide-chat-launcher').value)

  const { isIndex, path, journeyId } = AppRoute.use()
  const engine = EngineStore.use()

  const { isMobile } = Breakpoints.use()

  const onRequestChat = () => {
    console.log('launching chat from PxStickyFlowHelp')
    PxChat.show({ pxSource: 'stickyFlowHelp' })
  }

  const { unreadMessages } = PxChat.use()

  const hideHelpBar = computed(
    () =>
      (path.value == '/quotes' && engine.selectedPlanType !== PlanType.GAP) ||
      path.value == '/compare' ||
      path.value.includes('/details') ||
      path.value.includes('/apply') ||
      path.value == '/dashboard' ||
      path.value == '/standby' ||
      path.value == '/confirm' ||
      isHideCsChat.value ||
      (!isMobile.value && hideChatLauncher.value)
  )
</script>

<style scoped>
  #sticky-help-btn {
    @apply px-4 outline-4 outline-white;
    box-shadow: 0px 0px 20px rgba(55, 51, 255, 0.3), 0px 0px 10px rgba(0, 0, 0, 0.2);
  }
</style>
